import { articleListedLoadButtons as loadButtons } from './articleListedLoadButtons';
import * as els from './articleListedElements';
import * as handlers from './articleListedHandlers';

export const articleListedNavBar = (): void => {
  // Načtení tlačítek
  loadButtons();

  // Události | Kliknutí / tapnutí na telefonu
  ['click'].forEach((event) => {
    // Průběžné tlačítko 'Další'
    els.btnsNext.forEach((btnNext) => {
      btnNext.addEventListener(event, () => {
        handlers.next();
      });
    });

    // Průběžné tlačítko 'Předchozí'
    els.btnsPrev.forEach((btnPrev) => {
      btnPrev.addEventListener(event, () => {
        handlers.prev();
      });
    });

    // Poslední tlačítko 'Na začátek'
    els.btnsLast.forEach((btnLast) => {
      btnLast.addEventListener(event, () => {
        handlers.home();
      });
    });
  });

  // Události | Ovládání přes klávesy
  document.addEventListener('keydown', (event) => {
    // podpora i lokalizovaných kláves
    const left = event.code === 'ArrowLeft' || event.key === 'ArrowLeft';
    const right = event.code === 'ArrowRight' || event.key === 'ArrowRight';

    if (left) {
      handlers.prev();
    } else if (right) {
      handlers.next();
    }
  });
};
